import { registerPlugin } from "@capacitor/core";

export const FirebaseNative = registerPlugin("FirebaseNative");

export function isFirebaseNativeAvailable() {
  try {
    const cap = typeof window !== "undefined" ? window.Capacitor : null;
    const platform = cap?.getPlatform?.() || cap?.platform || "unknown";
    const isNative =
      typeof cap?.isNativePlatform === "function"
        ? cap.isNativePlatform()
        : platform !== "web";

    if (!isNative) return false;

    return (
      typeof FirebaseNative?.signInWithEmailPassword === "function" ||
      typeof FirebaseNative?.signInWithGoogle === "function" ||
      typeof FirebaseNative?.signInWithApple === "function" ||
      typeof FirebaseNative?.getBusinessesActive === "function" ||
      typeof FirebaseNative?.getBusinessServices === "function" ||
      typeof FirebaseNative?.getCurrentUserSession === "function" ||
      typeof FirebaseNative?.refreshSession === "function"
    );
  } catch (_) {
    return false;
  }
}

export async function signInWithEmailPassword({ email, password }) {
  if (!isFirebaseNativeAvailable()) {
    throw new Error("FirebaseNative plugin is not available on this platform");
  }
  return FirebaseNative.signInWithEmailPassword({ email, password });
}

export async function signInWithGoogle() {
  if (!isFirebaseNativeAvailable()) {
    throw new Error("FirebaseNative plugin is not available on this platform");
  }
  return FirebaseNative.signInWithGoogle();
}

export async function signInWithApple() {
  if (!isFirebaseNativeAvailable()) {
    throw new Error("FirebaseNative plugin is not available on this platform");
  }
  if (typeof FirebaseNative?.signInWithApple !== "function") {
    throw new Error("FirebaseNative.signInWithApple is not implemented in this build");
  }
  return FirebaseNative.signInWithApple();
}

export async function signOut() {
  if (!isFirebaseNativeAvailable()) {
    throw new Error("FirebaseNative plugin is not available on this platform");
  }
  return FirebaseNative.signOut();
}

export async function getCurrentUserSession() {
  if (!isFirebaseNativeAvailable()) {
    throw new Error("FirebaseNative plugin is not available on this platform");
  }
  return FirebaseNative.getCurrentUserSession();
}

export async function refreshSession() {
  if (!isFirebaseNativeAvailable()) {
    throw new Error("FirebaseNative plugin is not available on this platform");
  }
  return FirebaseNative.refreshSession();
}

export async function getBusinessesActive(options = {}) {
  if (!isFirebaseNativeAvailable()) {
    throw new Error("FirebaseNative plugin is not available on this platform");
  }
  return FirebaseNative.getBusinessesActive(options);
}

export async function getBusinessServices({ businessId }) {
  if (!isFirebaseNativeAvailable()) {
    throw new Error("FirebaseNative plugin is not available on this platform");
  }
  return FirebaseNative.getBusinessServices({ businessId });
}

try {
  if (typeof window !== "undefined") {
    window.__IOS_NATIVE_FIREBASE__ = {
      loaded: true,
      plugin: "FirebaseNative",
      timestamp: new Date().toISOString(),
    };
  }
} catch (_) {}
